export default "__VITE_ASSET__B39wd83h__"